/**
 * Stripe Payment Links accept query params; client_reference_id is sent back on checkout.session.completed
 * and must match the Firebase Auth uid (set server-side in the webhook).
 */
export function buildStripePaymentLinkUrl(baseUrl, firebaseUid) {
  if (!baseUrl || !firebaseUid) return baseUrl || "";
  try {
    const u = new URL(baseUrl);
    u.searchParams.set("client_reference_id", firebaseUid);
    return u.toString();
  } catch {
    return baseUrl;
  }
}
